/* eslint-disable no-nested-ternary */
import * as XLSX from 'xlsx';

import { formatVlanIdsWithUt } from '../export-helpers';
import { buildExportHeaderRows } from './header-rows';
import { type NodeExportData, type ExportHeaderInfo } from './types';

const TABLE_HEADERS = [
  'Name',
  'Model',
  'IP',
  'Port',
  'Connect Node',
  'Connect Port',
  'VLAN IDs',
  'PoE',
  'DHCP',
];

export const exportSwitchesToLibreOffice = async (
  switchesData: NodeExportData[],
  filename: string,
  headerInfo?: ExportHeaderInfo,
) => {
  const data: any[] = [];
  const merges: any[] = [];

  if (headerInfo) {
    const headerRows = buildExportHeaderRows(headerInfo, TABLE_HEADERS.length);
    headerRows.forEach((row) => data.push(row));
    if (headerRows.length > 1) {
      merges.push({
        s: { r: 0, c: 0 },
        e: { r: 0, c: TABLE_HEADERS.length - 1 },
      });
    }
  }

  data.push(TABLE_HEADERS);

  let startRow = data.length;

  switchesData.forEach((switchData) => {
    const ipCount = switchData.IP.length;
    const portCount = switchData.Port.length;
    const maxRows = Math.max(ipCount, portCount);

    for (let i = 0; i < maxRows; i += 1) {
      const portObj = switchData.Port[i] || {};
      const vlanStr = portObj.vlanIds?.length
        ? formatVlanIdsWithUt(portObj.vlanIds, portObj.untaggedVlan)
        : '';
      const poeStr =
        portObj.isPoeCapable === false
          ? '-'
          : portObj.poeEnabled
            ? 'Yes'
            : 'No';

      const rowValues = [
        i === 0 ? switchData.Name : '',
        i === 0 ? switchData.Model : '',
        i === 0
          ? switchData.IP.map((ip) =>
              ip.ip && ip.ip.trim() !== ''
                ? ip.subnetMask && ip.subnetMask.trim() !== ''
                  ? `${ip.ip} (${ip.subnetMask})`
                  : ip.ip
                : '',
            )
              .filter((ip) => ip !== '')
              .join('\n')
          : '',
        portObj.name || '',
        portObj.connectNode || '',
        portObj.connectPort || '',
        vlanStr,
        poeStr,
        portObj.dhcpEnabled ? 'Yes' : 'No',
      ];

      data.push(rowValues);
    }

    const endRow = startRow + maxRows - 1;
    if (endRow > startRow) {
      merges.push({ s: { r: startRow - 1, c: 0 }, e: { r: endRow - 1, c: 0 } });
      merges.push({ s: { r: startRow - 1, c: 1 }, e: { r: endRow - 1, c: 1 } });
      merges.push({ s: { r: startRow - 1, c: 2 }, e: { r: endRow - 1, c: 2 } });
    }

    startRow += maxRows;
  });

  const ws = XLSX.utils.aoa_to_sheet(data);
  ws['!merges'] = merges;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Report');

  XLSX.writeFile(wb, `${filename}.ods`, { bookType: 'ods', type: 'binary' });
};
